import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/analytics/page';

export const Route = createFileRoute('/_app/settings/analytics/')({
  component: Page,
});
